import type {
  PromotionMailTemplateForm,
  PromotionMailTemplateDto,
  IdAttachmentDto,
} from '@/services/ws-funnel/src/main/resources/rest-api';

import type { LanguageKey } from 'src/types.ts';

type MailTemplate = {
  subject: string;
  body: string;
};

export type PromotionMailTemplateFormValues = Record<LanguageKey, MailTemplate>;

// Creates mail template. Used to map server data to local mail template format.
export const createMailTemplate = (subject?: string, body?: string): MailTemplate => ({
  subject: subject || '',
  body: body || '',
});

export const mailTemplateFormFromApi = (template: PromotionMailTemplateDto): PromotionMailTemplateFormValues => ({
  en: createMailTemplate(template.subjectEn, template.textEn),
  fr: createMailTemplate(template.subjectFr, template.textFr),
  de: createMailTemplate(template.subject, template.text),
  it: createMailTemplate(template.subjectIt, template.textIt),
});

export const mailTemplateFormToApi = (
  form: PromotionMailTemplateFormValues,
  attachmentIds: IdAttachmentDto[],
): PromotionMailTemplateForm => ({
  subject: form.de.subject,
  subjectEn: form.en.subject,
  subjectFr: form.fr.subject,
  subjectIt: form.it.subject,

  text: form.de.body,
  textEn: form.en.body,
  textFr: form.fr.body,
  textIt: form.it.body,

  attachmentIds,
});
